import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { PatientClinicalScreen } from 'screens/patient';

export default withPermissions(PatientClinicalScreen, [
  GroupSecurity.MedicationStatementRead,
]);
